import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-password-input',
    templateUrl: './password-input.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PasswordInputComponent),
            multi: true
        }
    ],
    standalone: false
})
export class PasswordInputComponent implements ControlValueAccessor {
  @Input() placeholder: string = 'Password';
  @Input() maxlength: number = 25;
  @Input() id: string = '';
  @Input() name: string = '';
  @Input() className: string = 'password-icon';
  @Input('data-test-id') dataTestId: string = '';
  @Input() ngClass: string | string[] | Set<string> | { [klass: string]: any } = '';

  @Output() byKeyup = new EventEmitter<KeyboardEvent>();
  show = false;
  value = '';
  isDisabled = false;

  onChange = (value: string) => { };
  onTouched = () => { };

  toggle(): void {
    this.show = !this.show;
  }

  writeValue(value: string): void {
    this.value = value || '';
    this.onChange(this.value);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
  handleInput(event: Event) {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
    this.onChange(this.value);
  }
  handleKeyup(event: KeyboardEvent) {
    this.byKeyup.emit(event);
  }
}
